/** Werte aus dem Shop lesbar machen (Auftrag, Story 16): Bestellsprache und Zusatzfelder. */

const languageDisplay = new Intl.DisplayNames('de', { type: 'language' });

/** Bestellsprache auf Deutsch aus dem Sprachteil des Codes („de-AT“ → „Deutsch“, „cs-CZ“ → „Tschechisch“); unbekannt → Code. */
export function orderLanguageName(code: string | null): string {
  if (!code) return '–';
  const lang = code.split(/[-_]/)[0]!.toLowerCase();
  try {
    const name = /^[a-z]{2,3}$/.test(lang) ? languageDisplay.of(lang) : undefined;
    return name && name.toLowerCase() !== lang ? name : code;
  } catch {
    return code;
  }
}

const numberDe = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 20 });

/**
 * Wert eines Zusatzfelds aus dem Shop lesbar: Text wie geliefert, Ja/Nein, Zahl deutsch, Liste mit „, “; Objekte als
 * JSON. Leer → „–“.
 */
export function shopValueText(value: unknown): string {
  if (value === null || value === undefined || value === '') return '–';
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
  if (typeof value === 'number') return numberDe.format(value);
  if (Array.isArray(value) && value.length === 0) return '–';
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && value.every((v) => typeof v === 'string' || typeof v === 'number')) return value.map(shopValueText).join(', ');
  return JSON.stringify(value);
}

/**
 * Beschriftung aus einer festen Tabelle für einen Wert von außen (Shop, Server): nur eigene Schlüssel
 * (`Object.hasOwn`), sonst `null` – nie geerbte Eigenschaften wie „__proto__“ oder „constructor“.
 */
export function labelOf<T extends string>(map: Readonly<Record<string, T>>, key: string): T | null {
  return Object.hasOwn(map, key) ? map[key]! : null;
}

/** Herkunft der Bestellung im Shop (Shopware `order.source`) in Alltagssprache. */
const SHOP_SOURCE_NAMES: Readonly<Record<string, string>> = { storefront: 'Online-Shop', admin: 'Shop-Verwaltung', api: 'Schnittstelle' };

/** Herkunft im Shop lesbar; Unbekanntes (auch „__proto__“) wie geliefert. */
export function shopSourceName(source: string): string {
  return labelOf(SHOP_SOURCE_NAMES, source) ?? source;
}
